import axios from "axios";
import { loginreq, req, reqGet } from "../axiosFun";

// 查询银行卡手动提现审核列表
export const getTeamManualPayoutList = params => {
    return reqGet("get", "/app-yijiu-backstage/getTeamManualPayoutList", params);
};

// 审核银行卡手动提现 auditStatus 1审核通过 2审核不通过
export const auditTeamManualPayout = params => {
    return reqGet("get", "/app-yijiu-backstage/auditTeamManualPayout", params);
};

// 查询手动提现开关状态
export const getTeamBankManualState = params => {
    return reqGet("get", "/app-yijiu-backstage/getTeamBankManualState", params);
};

// 修改手动提现开关状态
export const updateTeamBankManualState = params => {
    return reqGet("get", "/app-yijiu-backstage/updateTeamBankManualState", params);
};


// 查询手动提现开关状态
export const getTeamAlipayState = params => {
    return reqGet("get", "/app-yijiu-backstage/getTeamAlipayState", params);
};

// 修改手动提现开关状态
export const updateTeamAlipayState = params => {
    return reqGet("get", "/app-yijiu-backstage/updateTeamAlipayState", params);
};

// 修改线下打款模式开关
export const updateOfflineMode = params => {
    return reqGet("get", "/app-yijiu-backstage/updateOfflineMode", params);
};






// WEBPACK FOOTER //
// ./src/api/manage/teamManualPayout.js